import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrSelect from '../components/FrSelect'

import api from '../services/api'

import './styles/Login.css';

import logo from '../imgs/logo-salute.png';
import delphus from '../imgs/delphus.png';

const swal = withReactContent(Swal)

function Login() {
    const [auth, setAuth] = useState(JSON.parse(localStorage['authsalute'] || JSON.stringify({ authenticated: false, user: 0 })));
    const [comboSed, setComboSed] = useState([{ value: '', display: '' }])
    const [sede, setSede] = useState('')
    const [usuario, setUsuario] = useState('')



    const handleChange = (e) => {
        if (e.target.name == 'login') {
            setUsuario(e.target.value)
        }
        if (e.target.name == 'fk_sed')
            setSede(e.target.value)
    };


    useEffect(() => {
        const fetchUnidades = async () => {
            if (usuario !== '') {
                let unidades = await api.getComboData('sedes', usuario)
                setComboSed(unidades)
            }
        }

        fetchUnidades()
    }, [usuario])



    useEffect(() => {
        if (auth.authenticated) {
            window.location.href = '/salute/home'
        }

    }, [auth])


    function login(e) {
        e.preventDefault();
        //Pega valores do form
        const form = document.getElementById('loginForm');
        const data = new FormData(form);

        if (data.get('login') === '') {
            swal.fire('Usuário não informado!', 'Informe o usuário.', 'warning')
            return
        }

        if (data.get('senha') === '') {
            swal.fire('Senha não informada!', 'Informe a senha.', 'warning')
            return
        }

        // if (!sede) {
        //     swal.fire('Sede não informada!', 'Informe a sede.', 'warning')
        //     return
        // }

        //Converte FormData em JSON
        var object = {};

        data.forEach(function (value, key) {
            object[key] = value;
        });

        //Checa no servidor
        api.post('usuarios/login', object)
            .then(function (response) {
                let { pk_usu, nome, ativo } = response.data[0];
                if (ativo == 'S') {
                    if (pk_usu && pk_usu > 0) {
                        localStorage['authsalute'] = JSON.stringify({ authenticated: true, user: pk_usu, name: nome, pk_sed: sede, last_activity: new Date(), temaEscuro: false })
                        window.location.href = '/salute/home'
                    } else {
                        swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
                    }
                } else {
                    swal.fire(
                        "Login inválido!",
                        "Usuário inativo! Acesso não permitido!",
                        "warning"
                    );
                }
            })
            .catch(function (error) {
                swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
            });
    }

    return (
        <div className="Login">
            <div className="form">
                <form className="form-signin" id="loginForm" onSubmit={login}>
                    <img alt="logo" src={logo} title="salute" className="logo" />
                    <div className="form-label-group">
                        <input autoFocus type="text" id="login" name="login" className="loginInput" placeholder="Usuário" onBlur={handleChange} />
                        <label htmlFor="login">Login</label>
                    </div>
                    <div className="form-label-group">
                        <input type="password" id="senha" name="senha" className="loginInput" placeholder="Senha" />
                        <label htmlFor="senha">Senha</label>
                    </div>

                    <div className="form-label-group">

                        <FrSelect
                            style={{ border: '1px solid #083c7c', width: '100%', borderRadius: '4px', position: 'relative' }}
                            name="fk_sed"
                            id="fk_sed"
                            label='Sede'
                            data={comboSed}
                            value={sede}
                            onChange={handleChange}
                        />

                    </div>
                    <button className="loginButton" type="submit" rel="nofollow">
                        <span><p className='loginButtonText'>Entrar</p></span>
                    </button>
                    <div className="forgotPwDiv">
                        <a href='/salute/forgotPw'>Esqueci minha senha</a>
                    </div>

                </form>
            </div>
            <div className="delphus">
                <img alt="delphus" src={delphus} title="delphus" className="logo_delphus" />
            </div>
        </div>
    );
}

export default Login;
